import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

import {
  MAX_LETTER_COUNT,
  FeedbackTextValues,
} from 'pages/ParentHelper/components/Chat/components/Body/components/Answer/components/FeedbackButtons/components/FeedbackDislikeDialog/components/FeedbackDislikeDialogForm/constants';

import type { Fields } from 'pages/ParentHelper/components/Chat/components/Footer/types';

export const useValidation = () => {
  const { t } = useTranslation();

  return yup.object<Fields>().shape({
    messageId: yup.string().required(),
    inspiredGlobalStudyPlatformApiModelsParentHelperAnswerFeedbackRequest: yup
      .object()
      .shape({
        liked: yup.bool().required().oneOf([false]),
        feedbackText: yup
          .string()
          .required()
          .oneOf(Object.values(FeedbackTextValues)),
        otherFeedbackText: yup
          .string()
          .trim()
          .max(
            MAX_LETTER_COUNT,
            t('pages.parentHelper.chat.validation.max', {
              characters: MAX_LETTER_COUNT,
            }),
          )
          .when('feedbackText', {
            is: FeedbackTextValues.other,
            then: schema =>
              schema.required(t('pages.parentHelper.chat.validation.required')),
          }),
      }),
  });
};
